import React, { useState } from "react";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import Bgimage from "./images/customerbanner.webp";
import { useTranslation } from "react-i18next";
import FlowchartImg from "./images/flowchart.png";

export const Customercare = () => {
  const { t, i18n } = useTranslation();
  const [lang, setLang] = useState(i18n.language);

  React.useEffect(() => {
    const savedLang = localStorage.getItem("lang");
    if (savedLang) {
      i18n.changeLanguage(savedLang);
      setLang(savedLang);
    }
  }, []);
  const changeLanguage = (lng) => {
    setLang(lng);
    i18n.changeLanguage(lng);
    localStorage.setItem("lang", lng); // ✅ save
  };

  return (
    <>
      <Header />

      <section id="banner" className="p-0">
        <div
          className="banner"
          style={{
            backgroundImage: "url(" + Bgimage + ")",
            height: "68vh",
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        ></div>
      </section>

      <section id="contactpage" className="p-0">
        <div className="contactpage">
          <div className="container">
            <div className="row">
              <div className="web-container">
                {/* Title */}
                <div className="title" style={{ marginTop: "30px" }}>
                  <span>{t("title")}</span>
                </div>

                {/* Radio Buttons */}
                <div style={{ textAlign: "center", margin: "15px 0 25px" }}>
                  <label style={{ marginRight: "20px" }}>
                    <input
                      type="radio"
                      checked={lang === "en"}
                      onChange={() => changeLanguage("en")}
                    />{" "}
                    English
                  </label>

                  <label style={{ marginRight: "20px" }}>
                    <input
                      type="radio"
                      checked={lang === "hi"}
                      onChange={() => changeLanguage("hi")}
                    />{" "}
                    हिंदी
                  </label>

                  <label>
                    <input
                      type="radio"
                      checked={lang === "pa"}
                      onChange={() => changeLanguage("pa")}
                    />{" "}
                    ਪੰਜਾਬੀ
                  </label>
                </div>

                {/* Content */}
                <div className="contactoverview">
                  <div className="contactbox">
                    <h3>{t("Customer Care")}</h3>
                    <ul>
                      <li>
                        <span>{t("call")}</span>
                        <p>
                          <a href="tel:+917087570875">+91-70875-70875</a>
                        </p>
                      </li>
                      <li>
                        <span>{t("email")}</span>
                        <p>
                          <a href="mailto:customercare@netplus.co.in">
                            customercare@netplus.co.in
                          </a>
                        </p>
                      </li>
                      {/* <li>
                        <span>{t("Address")}</span>
                        <p>
                          <a href="https://goo.gl/maps/xsS1au4KsvQBJroX8">
                            Address : Netplus Broadband Services Pvt Ltd. 5th
                            floor The Grand Walk Mall, H Block Ludhiana 141012
                          </a>
                        </p>
                      </li> */}
                    </ul>
                  </div>

                  <div className="contactbox">
                    <h3 style={{ whiteSpace: "nowrap" }}>
                      {t("Appellate Authority")}
                    </h3>
                    <ul>
                      <li>
                        <span>{t("Name")}</span>
                        <p>{t("lsaPerson")}</p>
                      </li>
                      <li>
                        <span>{t("call")}</span>
                        <p>
                          <a href="tel:0161-4044409">0161-4044409</a>
                        </p>
                      </li>
                      <li>
                        <span>{t("email")}</span>
                        <p>
                          <a href="appellate.authority@netplus.co.in">
                            appellate.authority@netplus.co.in
                          </a>
                        </p>
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="contactoverview">
                  <div className="contactbox">
                    <h3>{t("address")}</h3>

                    <div className="office">
                      <div className="officebox">
                        <h4>{t("city")}</h4>
                        <ul>
                          <li>{t("fullAddress")}</li>

                          <li>
                            <span>
                              <a
                                href="https://goo.gl/maps/xsS1au4KsvQBJroX8"
                                target="_blank"
                              >
                                {t("viewMap")}
                              </a>
                            </span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div className="contactbox">
                    <h3>{t("Complaint Resolution Timelines")}</h3>
                    <ul>
                      <li>
                        <p>{t("resolutionTime")}</p>
                      </li>
                    </ul>
                  </div>
                </div>
                <div style={{ textAlign: "center", marginBottom: "20px" }}>
                  <h2
                    style={{
                      fontSize: "28px",
                      fontWeight: "600",
                      marginBottom: "10px",
                    }}
                  >
                    Customer Complaint Resolution Process
                  </h2>

                  <img
                    src={FlowchartImg}
                    alt="Customer Support Flowchart"
                    style={{
                      maxWidth: "100%",
                      height: "auto",
                      borderRadius: "10px",
                    }}
                  />
                </div>
              </div>
            </div>
          </div>

          <Footer />
        </div>
      </section>
    </>
  );
};
